module.exports = __webpack_public_path__ + "static/img/power-img01-02.d5625d4.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/resolution/power-img01-02.png
// module id = g9nX
// module chunks = 7